import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    campusesMap: {},
  },
  mutations: {
    setCampuses: function (state, campuses) {
      state.campusesMap = _.keyBy(campuses, "id");
    },
    updateCampus: function (state, campus) {
      state.campusesMap = {
        ...state.campusesMap,
        [campus.id]: campus,
      };
    },
  },
  getters: {
    campusesList(state) {
      return _.sortBy(Object.values(state.campusesMap), "name");
    },
    campusesOptions(state, getters) {
      return getters.campusesList.map((t) => ({ value: t.id, text: t.name }));
    },
  },
};
